import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Nat Habitat";

export default function SEO({ title, description, image, path = "", type = "website", jsonLd }) {
  const fullTitle = title ? (title.includes(SITE) ? title : `${title} — ${SITE}`) : SITE;
  const url = `https://nathabitat.com${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {image && <meta property="og:image" content={image} />}
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {image && <meta name="twitter:image" content={image} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
